import { naturalSort } from 'utils/sorting';
import * as api from '../../../../api';

const ROLES_CONFIG_URL = '/api/partner/roles/config';

const ERROR_EXISTS_NAME =
    'Partner role with this Name and Organization already exists.';

export const loadRoles = async companyId => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/roles`
    );
    return data;
};

export const loadRolesConfig = async () => {
    const { data } = await api.get(ROLES_CONFIG_URL);
    return groupRoles(data);
};

export const createRole = async (data, companyId) => {
    const { role, error, details = [] } = await api.post(
        `/api/organization/${companyId}/partner/roles`,
        data
    );
    if (error && details) {
        throw processSaveErrors(details);
    } else {
        return role;
    }
};

export const loadRole = async (id, companyId) => {
    const { data } = await api.get(
        `/api/organization/${companyId}/partner/roles/${id}`
    );
    return data;
};

export const updateRole = async (id, data, companyId) => {
    data.uuid = id;
    const { role } = await api.patch(
        `/api/organization/${companyId}/partner/roles`,
        data
    );
    return role;
};

export const removeRoles = async (roles, companyId) => {
    const uuids = roles.map(role => ({ uuid: role.uuid }));
    await api.remove(`/api/organization/${companyId}/partner/roles`, uuids);
};

export const loadCompany = async companyId => {
    const { data } = await api.get(`/api/organizations/${companyId}`);
    return data[0];
};

function processSaveErrors(details) {
    const extractError = detail => {
        const index = detail.indexOf(':');
        if (index !== -1) {
            const name = detail.substr(0, index);
            const message = detail.substr(index + 2);
            return {
                name,
                message,
            };
        }
    };
    const filterEmpty = error => !!error;
    const checkNameExists = error => {
        const { name, message } = error;
        if (name === '__all__') {
            if (message === ERROR_EXISTS_NAME) {
                return {
                    name: 'name',
                    message: {
                        serverSide: true,
                        message: 'Role already exists.',
                    },
                };
            }
        }
        return error;
    };
    const groupByName = (errors, error) => {
        errors[error.name] = error.message;
        return errors;
    };
    return details
        .map(extractError)
        .filter(filterEmpty)
        .map(checkNameExists)
        .reduce(groupByName, {});
}

const GROUPS = [
    {
        name: 'companies',
        label: 'Companies',
        pattern: /^companies/,
    },
    {
        name: 'account',
        label: 'Account',
        pattern: /^account/,
    },
    {
        name: 'others',
        label: 'Others',
        pattern: /.*/,
    },
];

function groupRoles(config) {
    const findGroup = name => GROUPS.find(({ pattern }) => pattern.test(name));
    const groupedConfig = Object.keys(config).reduce((acc, name) => {
        const group = findGroup(name);
        if (group) {
            if (!acc[group.name]) {
                acc[group.name] = [];
            }
            acc[group.name].push({
                name,
                value: config[name],
            });
        }
        return acc;
    }, {});
    return GROUPS.map(({ name, label }) => {
        const options = naturalSort(
            groupedConfig[name] || [],
            rule => rule.value
        );
        return {
            name,
            label,
            options,
        };
    }).filter(group => group.options.length);
}
